exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2rKHh{margin-left:12px;white-space:nowrap}\n", ""]);

// Exports
exports.locals = {
	"button": "_2rKHh"
};